import moment from 'moment';

const getLoaderState = (state) => state.log.loading;

const getLogs = (state) => state.log.logs;

const todaysLogs = (state) => {
  const logs = state.log.logs.filter((item) => {
    if (!moment(item.createdAt).diff(moment(), 'day')) {
      return true;
    }
    return false;
  });
  return logs;
};

const selectors = {
  getLoaderState,
  getLogs,
  todaysLogs,
};

export default selectors;
